/**
 * Sunset Shore — beach zone south of the fairgrounds (world y 5560-6360).
 * Amphitheater w/ live-stream mega screen, volleyball court, swimmable ocean, jet-ski.
 */

export const SHORE_TOP = 5560;
export const WATER = { x1: 60, y1: 6020, x2: 740, y2: 6320 };
export const JETSKI_DOCK = { x: 110, y: 5990 };
export const AMPH_SCREEN = { x1: 80, y1: 5560, x2: 440, y2: 5710 };

export const inWater = (x, y) => x > WATER.x1 && x < WATER.x2 && y > WATER.y1 && y < WATER.y2;

export function updateVolley(v) {
  if (v.p < 1) {
    v.p = Math.min(1, v.p + 0.028);
    v.x = v.fromX + (v.toX - v.fromX) * v.p;
    v.y = v.fromY + (v.toY - v.fromY) * v.p;
    v.z = Math.sin(v.p * Math.PI) * 70;
  } else v.z = 0;
}

export function drawSwimOverlay(ctx, x, y, t) {
  ctx.save();
  ctx.fillStyle = 'rgba(56,189,248,0.55)';
  ctx.beginPath(); ctx.ellipse(x, y - 26 + Math.sin(t * 0.1) * 1.5, 26, 7, 0, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = 'rgba(255,255,255,0.55)'; ctx.lineWidth = 1.5;
  ctx.beginPath(); ctx.ellipse(x, y - 28, 21 + Math.sin(t * 0.14) * 3, 5, 0, 0, Math.PI * 2); ctx.stroke();
  ctx.strokeStyle = 'rgba(255,255,255,0.25)';
  ctx.beginPath(); ctx.ellipse(x, y - 28, 30 + Math.sin(t * 0.14 + 1) * 4, 8, 0, 0, Math.PI * 2); ctx.stroke();
  ctx.restore();
}

export function drawJetSki(ctx, x, y, dir, t, moving) {
  const flip = dir === 'left' ? -1 : 1;
  const bob = Math.sin(t * 0.18) * 1.6;
  ctx.save();
  ctx.translate(x, y - 14 + bob);
  ctx.scale(flip, 1);
  if (moving) {
    for (let i = 0; i < 5; i++) {
      ctx.fillStyle = `rgba(224,242,254,${0.5 - i * 0.09})`;
      ctx.beginPath();
      ctx.arc(-34 - i * 9, 12 + Math.sin(t * 0.3 + i) * 4, 5 - i * 0.6, 0, Math.PI * 2);
      ctx.fill();
    }
  }
  ctx.fillStyle = '#e11d48';
  ctx.beginPath();
  ctx.moveTo(-30, 8); ctx.quadraticCurveTo(-34, -2, -22, -4);
  ctx.lineTo(18, -6); ctx.quadraticCurveTo(38, -4, 34, 6);
  ctx.quadraticCurveTo(20, 14, -12, 13); ctx.closePath(); ctx.fill();
  ctx.fillStyle = '#9f1239';
  ctx.fillRect(-16, -8, 22, 6);
  ctx.strokeStyle = '#cbd5e1'; ctx.lineWidth = 3;
  ctx.beginPath(); ctx.moveTo(10, -6); ctx.lineTo(20, -16); ctx.stroke();
  ctx.fillStyle = '#cbd5e1';
  ctx.fillRect(14, -20, 12, 4);
  ctx.fillStyle = 'rgba(224,242,254,0.7)';
  ctx.beginPath(); ctx.ellipse(2, 14, 30, 5, 0, 0, Math.PI * 2); ctx.fill();
  ctx.restore();
}

export function drawBeachZone(ctx, cam, t, opts = {}) {
  const H = ctx.canvas.height;
  if (SHORE_TOP - cam > H + 60) return; // not visible yet
  const { liveRoom, coverImg, volley, jetskiTaken, video } = opts;

  // sand (painted extra-wide so horizontal camera pan never shows void)
  const sandY = SHORE_TOP - cam;
  ctx.fillStyle = '#dfc08a';
  ctx.fillRect(-1450, sandY, 3700, WATER.y1 - SHORE_TOP + 40);
  ctx.fillStyle = 'rgba(0,0,0,0.05)';
  for (let i = 0; i < 24; i++) {
    const sx = (i * 137) % 780; const sy = SHORE_TOP + 90 + ((i * 211) % 400);
    ctx.fillRect(sx, sy - cam, 14, 3);
  }
  // boardwalk edge
  ctx.fillStyle = '#7c5a3a';
  ctx.fillRect(-1450, sandY - 14, 3700, 16);
  ctx.strokeStyle = 'rgba(0,0,0,0.25)';
  for (let px = -1450; px < 2250; px += 26) { ctx.beginPath(); ctx.moveTo(px, sandY - 14); ctx.lineTo(px, sandY + 2); ctx.stroke(); }
  // banner
  ctx.font = 'bold 15px monospace'; ctx.textAlign = 'center';
  ctx.fillStyle = '#fb923c';
  ctx.shadowColor = '#fb923c'; ctx.shadowBlur = 10;
  ctx.fillText('🌅 SUNSET SHORE 🌅', 340, sandY + 24);
  ctx.shadowBlur = 0;

  // ===== AMPHITHEATER =====
  const ax1 = AMPH_SCREEN.x1, ay = AMPH_SCREEN.y1 - cam;
  // stage base
  ctx.fillStyle = '#312a3e';
  ctx.fillRect(ax1 - 20, ay + 130, 400, 30);
  ctx.fillStyle = '#211c2c';
  ctx.fillRect(ax1 - 20, ay + 156, 400, 8);
  // screen frame + panel
  ctx.fillStyle = '#0b0a12';
  ctx.fillRect(ax1 - 10, ay, 380, 140);
  ctx.strokeStyle = `rgba(251,146,60,${0.55 + Math.abs(Math.sin(t * 0.06)) * 0.45})`;
  ctx.lineWidth = 3;
  ctx.strokeRect(ax1 - 10, ay, 380, 140);
  const sx0 = ax1 + 2, sy0 = ay + 10, sw = 356, sh = 108;
  if (liveRoom) {
    // live content: real camera feed when available, else cover + EQ bars
    const hasFeed = video && video.readyState >= 2 && video.srcObject;
    if (hasFeed) {
      try { ctx.drawImage(video, sx0, sy0, sw, sh); } catch (e) { /* noop */ }
      ctx.fillStyle = 'rgba(0,0,0,0.18)';
      ctx.fillRect(sx0, sy0 + sh - 26, sw, 26);
    } else if (coverImg && coverImg.complete && coverImg.naturalWidth) {
      try { ctx.drawImage(coverImg, sx0, sy0, sw, sh); } catch (e) { /* noop */ }
      ctx.fillStyle = 'rgba(0,0,0,0.45)';
      ctx.fillRect(sx0, sy0, sw, sh);
    } else {
      ctx.fillStyle = '#170f26';
      ctx.fillRect(sx0, sy0, sw, sh);
    }
    if (!hasFeed) {
      ctx.font = 'bold 12px monospace'; ctx.textAlign = 'center';
      ctx.fillStyle = `rgba(148,163,184,${0.4 + Math.abs(Math.sin(t * 0.09)) * 0.6})`;
      ctx.fillText('📡 CONNECTING TO STAGE CAM…', sx0 + sw / 2, sy0 + sh - 14);
      ctx.textAlign = 'left';
    }
    ctx.fillStyle = '#ef4444';
    ctx.fillRect(sx0 + 8, sy0 + 8, 46, 16);
    ctx.font = 'bold 10px monospace'; ctx.textAlign = 'left';
    ctx.fillStyle = '#fff';
    ctx.fillText('● LIVE', sx0 + 12, sy0 + 20);
    ctx.font = 'bold 13px sans-serif';
    ctx.fillText(String(liveRoom.title || '').slice(0, 34), sx0 + 8, sy0 + 46);
    ctx.font = '11px sans-serif';
    ctx.fillStyle = 'rgba(255,255,255,0.8)';
    ctx.fillText(`${liveRoom.host_name || 'Host'} · 👁 ${liveRoom.viewer_count ?? 0} watching`, sx0 + 8, sy0 + 62);
    ctx.font = `bold 10px monospace`;
    ctx.fillStyle = `rgba(251,146,60,${0.5 + Math.abs(Math.sin(t * 0.08)) * 0.5})`;
    ctx.fillText('TAP SCREEN TO WATCH ▶', sx0 + 8, sy0 + sh - 10);
  } else {
    ctx.fillStyle = '#12101c';
    ctx.fillRect(sx0, sy0, sw, sh);
    const gl = 0.35 + Math.abs(Math.sin(t * 0.05)) * 0.4;
    ctx.font = 'bold 15px monospace'; ctx.textAlign = 'center';
    ctx.fillStyle = `rgba(148,163,184,${gl})`;
    ctx.fillText('NOBODY LIVE RIGHT NOW', sx0 + sw / 2, sy0 + 48);
    ctx.font = '11px monospace';
    ctx.fillText('tap to browse or go live', sx0 + sw / 2, sy0 + 70);
  }
  // benches
  for (let r = 0; r < 3; r++) {
    const by = ay + 190 + r * 34;
    ctx.fillStyle = '#5c4630';
    ctx.fillRect(ax1 + 10 + r * 16, by, 340 - r * 32, 10);
    ctx.fillStyle = 'rgba(0,0,0,0.3)';
    ctx.fillRect(ax1 + 10 + r * 16, by + 10, 340 - r * 32, 3);
  }
  ctx.font = 'bold 11px monospace'; ctx.textAlign = 'center';
  ctx.fillStyle = 'rgba(255,255,255,0.55)';
  ctx.fillText('AMPHITHEATER PARK', ax1 + 180, ay + 306);

  // ===== VOLLEYBALL COURT =====
  const vy = 5770 - cam;
  ctx.strokeStyle = 'rgba(255,255,255,0.6)';
  ctx.lineWidth = 2;
  ctx.strokeRect(480, vy, 250, 190);
  // net
  ctx.strokeStyle = '#e2e8f0';
  ctx.beginPath(); ctx.moveTo(605, vy - 26); ctx.lineTo(605, vy + 190); ctx.stroke();
  ctx.lineWidth = 1;
  for (let i = 0; i < 5; i++) { ctx.beginPath(); ctx.moveTo(600, vy - 22 + i * 8); ctx.lineTo(610, vy - 22 + i * 8); ctx.stroke(); }
  ctx.font = 'bold 9px monospace';
  ctx.fillStyle = 'rgba(255,255,255,0.6)';
  ctx.fillText(`🏐 tap the ball! rally: ${volley?.count || 0}`, 605, vy + 208);
  if (volley) {
    updateVolley(volley);
    const bx = volley.x, by = volley.y - cam;
    ctx.fillStyle = 'rgba(0,0,0,0.25)';
    ctx.beginPath(); ctx.ellipse(bx, by, 8 - volley.z * 0.04, 3.5, 0, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#fbbf24';
    ctx.beginPath(); ctx.arc(bx, by - 6 - volley.z, 8, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = '#b45309'; ctx.lineWidth = 1.2;
    ctx.beginPath(); ctx.arc(bx, by - 6 - volley.z, 8, 0.4, 2.2); ctx.stroke();
    ctx.beginPath(); ctx.arc(bx, by - 6 - volley.z, 8, 3.4, 5.4); ctx.stroke();
  }

  // umbrellas + towels (between the amphitheater and the waterline)
  [[240, 5945, '#ef4444'], [340, 5958, '#38bdf8'], [430, 5938, '#a3e635']].forEach(([ux, uy, c]) => {
    const yy = uy - cam;
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.beginPath(); ctx.ellipse(ux + 26, yy + 26, 22, 8, 0, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = c === '#38bdf8' ? '#fda4af' : '#e0f2fe';
    ctx.fillRect(ux + 8, yy + 16, 38, 18);
    ctx.strokeStyle = '#8a6a4a'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(ux, yy + 14); ctx.lineTo(ux, yy - 26); ctx.stroke();
    ctx.fillStyle = c;
    ctx.beginPath(); ctx.arc(ux, yy - 26, 24, Math.PI, 0); ctx.fill();
    ctx.fillStyle = 'rgba(255,255,255,0.3)';
    ctx.beginPath(); ctx.arc(ux, yy - 26, 24, Math.PI + 0.5, Math.PI + 1.1); ctx.lineTo(ux, yy - 26); ctx.fill();
  });

  // ===== OCEAN =====
  const wy1 = WATER.y1 - cam;
  const grad = ctx.createLinearGradient(0, wy1, 0, wy1 + 320);
  grad.addColorStop(0, '#38bdf8');
  grad.addColorStop(0.5, '#0284c7');
  grad.addColorStop(1, '#075985');
  ctx.fillStyle = grad;
  ctx.fillRect(-1450, wy1, 3700, WATER.y2 - WATER.y1 + 40);
  // foam edge
  ctx.strokeStyle = 'rgba(255,255,255,0.8)';
  ctx.lineWidth = 3;
  ctx.beginPath();
  for (let px = -1450; px <= 2250; px += 16) {
    const fy = wy1 + Math.sin(px * 0.05 + t * 0.06) * 4;
    px === -1450 ? ctx.moveTo(px, fy) : ctx.lineTo(px, fy);
  }
  ctx.stroke();
  // waves
  ctx.strokeStyle = 'rgba(255,255,255,0.28)';
  ctx.lineWidth = 2;
  for (let row = 0; row < 5; row++) {
    const base = wy1 + 50 + row * 52;
    ctx.beginPath();
    for (let px = -1450; px <= 2250; px += 20) {
      const fy = base + Math.sin(px * 0.04 + t * 0.08 + row * 2) * 5;
      px === -1450 ? ctx.moveTo(px, fy) : ctx.lineTo(px, fy);
    }
    ctx.stroke();
  }
  ctx.font = 'bold 10px monospace'; ctx.textAlign = 'center';
  ctx.fillStyle = `rgba(255,255,255,${0.4 + Math.abs(Math.sin(t * 0.05)) * 0.35})`;
  ctx.fillText('～ walk in to swim ～', 400, wy1 + 34);

  // jet-ski dock
  const jy = JETSKI_DOCK.y - cam;
  ctx.fillStyle = '#7c5a3a';
  ctx.fillRect(JETSKI_DOCK.x - 50, jy - 6, 110, 46);
  ctx.strokeStyle = 'rgba(0,0,0,0.25)';
  for (let i = 0; i < 5; i++) { ctx.beginPath(); ctx.moveTo(JETSKI_DOCK.x - 50 + i * 24, jy - 6); ctx.lineTo(JETSKI_DOCK.x - 50 + i * 24, jy + 40); ctx.stroke(); }
  if (!jetskiTaken) {
    drawJetSki(ctx, JETSKI_DOCK.x, jy + 52, 'right', t, false);
    ctx.font = 'bold 9px monospace';
    ctx.fillStyle = `rgba(253,224,71,${0.5 + Math.abs(Math.sin(t * 0.07)) * 0.5})`;
    ctx.fillText('🌊 tap to ride!', JETSKI_DOCK.x + 4, jy - 12);
  }

  // palms
  [[40, 5700], [740, 5680], [700, 5980]].forEach(([px2, py2]) => {
    const yy = py2 - cam;
    ctx.strokeStyle = '#8a6a4a'; ctx.lineWidth = 5;
    ctx.beginPath(); ctx.moveTo(px2, yy); ctx.quadraticCurveTo(px2 + 6, yy - 30, px2 + 2, yy - 56); ctx.stroke();
    ctx.fillStyle = '#22c55e';
    for (let l = 0; l < 5; l++) {
      const a = (l / 5) * Math.PI * 2 + Math.sin(t * 0.03) * 0.1;
      ctx.beginPath();
      ctx.ellipse(px2 + 2 + Math.cos(a) * 16, yy - 58 + Math.sin(a) * 7, 15, 5, a, 0, Math.PI * 2);
      ctx.fill();
    }
  });
}

// ===== THEGODS — Randall's clifftop mega-mansion (world x 640-795, base y 5560) =====
export const GODS_TOWER = { x1: 640, y1: 5205, x2: 795, y2: 5565 };

export function drawGodsTower(ctx, cam, t) {
  const bx = 717, by = 5560 - cam;
  if (by < -400 || by - 380 > ctx.canvas.height + 60) return;
  // tower body (6 floors incl. basement below street)
  ctx.fillStyle = '#171022';
  ctx.fillRect(bx - 72, by - 340, 144, 340);
  ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 3;
  ctx.strokeRect(bx - 72, by - 340, 144, 340);
  for (let fl = 0; fl < 5; fl++) {
    const fy = by - 320 + fl * 64;
    ctx.strokeStyle = 'rgba(255,215,0,0.3)'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(bx - 72, fy + 54); ctx.lineTo(bx + 72, fy + 54); ctx.stroke();
    [-48, -4, 40].forEach((wo, wi) => {
      const on = ((fl * 3 + wi + Math.floor(t / 60)) % 4) !== 0;
      ctx.fillStyle = on ? 'rgba(253,230,138,0.85)' : 'rgba(20,14,30,0.9)';
      ctx.fillRect(bx + wo, fy + 10, 22, 30);
    });
  }
  // rooftop club dome + lasers
  ctx.fillStyle = '#0e0616';
  ctx.beginPath(); ctx.arc(bx, by - 344, 46, Math.PI, 0); ctx.fill();
  ctx.strokeStyle = '#c084fc'; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.arc(bx, by - 344, 46, Math.PI, 0); ctx.stroke();
  for (let l = 0; l < 3; l++) {
    const a = -Math.PI / 2 + Math.sin(t * 0.05 + l * 2.1) * 0.9;
    ctx.strokeStyle = `hsla(${(t * 3 + l * 120) % 360}, 90%, 60%, 0.7)`;
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(bx, by - 352);
    ctx.lineTo(bx + Math.cos(a) * 90, by - 352 + Math.sin(a) * 90); ctx.stroke();
  }
  // observatory mini-dome + telescope
  ctx.fillStyle = '#1e293b';
  ctx.beginPath(); ctx.arc(bx + 52, by - 330, 16, Math.PI, 0); ctx.fill();
  ctx.strokeStyle = '#94a3b8'; ctx.lineWidth = 3;
  ctx.beginPath(); ctx.moveTo(bx + 52, by - 338); ctx.lineTo(bx + 64, by - 352); ctx.stroke();
  // vertical THEGODS neon sign
  const gl = 0.6 + Math.abs(Math.sin(t * 0.07)) * 0.4;
  ctx.font = 'bold 15px monospace'; ctx.textAlign = 'center';
  ctx.fillStyle = `rgba(255,215,0,${gl})`;
  ctx.shadowColor = '#FFD700'; ctx.shadowBlur = 12 * gl;
  'THEGODS'.split('').forEach((ch, i) => ctx.fillText(ch, bx - 58, by - 296 + i * 38));
  ctx.shadowBlur = 0;
  // door + plaque
  ctx.fillStyle = '#2b1c0e';
  ctx.fillRect(bx - 20, by - 52, 40, 52);
  ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 2;
  ctx.strokeRect(bx - 20, by - 52, 40, 52);
  ctx.fillStyle = 'rgba(0,0,0,0.7)';
  ctx.fillRect(bx - 62, by + 6, 124, 16);
  ctx.font = 'bold 11px serif';
  ctx.fillStyle = '#FFD700';
  ctx.shadowColor = '#FFD700'; ctx.shadowBlur = 6;
  ctx.fillText('★ THEGODS ★', bx, by + 18);
  ctx.shadowBlur = 0;
  ctx.font = 'bold 8px monospace';
  ctx.fillStyle = `rgba(255,255,255,${0.4 + gl * 0.4})`;
  ctx.fillText('tap to enter', bx, by - 58);
}

// Randall's gated plot — fence, animated gate and driveway in front of THEGODS.
// gateOpen: 0 (closed) .. 1 (fully open)
export const GODS_GATE = { x: 717, y: 5650 };

export function drawGodsGate(ctx, cam, t, gateOpen = 0) {
  const gy = GODS_GATE.y - cam;
  if (gy < -260 || gy > ctx.canvas.height + 200) return;
  // driveway leading up to the gate
  ctx.fillStyle = '#3f3a4a';
  ctx.fillRect(690, gy + 4, 56, 118);
  ctx.strokeStyle = 'rgba(255,215,0,0.4)'; ctx.lineWidth = 2;
  ctx.strokeRect(690, gy + 4, 56, 118);
  ctx.strokeStyle = 'rgba(255,255,255,0.18)'; ctx.lineWidth = 1;
  for (let i = 1; i < 6; i++) { ctx.beginPath(); ctx.moveTo(690, gy + 4 + i * 20); ctx.lineTo(746, gy + 4 + i * 20); ctx.stroke(); }
  ctx.setLineDash([8, 8]);
  ctx.strokeStyle = 'rgba(253,224,71,0.5)';
  ctx.beginPath(); ctx.moveTo(718, gy + 8); ctx.lineTo(718, gy + 118); ctx.stroke();
  ctx.setLineDash([]);
  // side fence returns up to the tower base
  ctx.strokeStyle = '#b8860b'; ctx.lineWidth = 3;
  [622, 812].forEach((fx) => {
    ctx.beginPath(); ctx.moveTo(fx, gy); ctx.lineTo(fx, gy - 84); ctx.stroke();
    for (let i = 0; i < 4; i++) {
      ctx.beginPath(); ctx.moveTo(fx - 4, gy - i * 24); ctx.lineTo(fx + 4, gy - i * 24); ctx.stroke();
    }
  });
  // front fence (bars + spear tops), opening at x 687-747
  const bar = (x) => {
    ctx.beginPath(); ctx.moveTo(x, gy); ctx.lineTo(x, gy - 34); ctx.stroke();
    ctx.fillStyle = '#FFD700';
    ctx.beginPath(); ctx.moveTo(x - 3, gy - 34); ctx.lineTo(x, gy - 42); ctx.lineTo(x + 3, gy - 34); ctx.closePath(); ctx.fill();
  };
  ctx.strokeStyle = '#b8860b'; ctx.lineWidth = 3;
  for (let x = 622; x <= 687; x += 13) bar(x);
  for (let x = 747; x <= 812; x += 13) bar(x);
  // rails
  ctx.strokeStyle = '#8a6a1a'; ctx.lineWidth = 4;
  ctx.beginPath(); ctx.moveTo(622, gy - 8); ctx.lineTo(687, gy - 8); ctx.moveTo(747, gy - 8); ctx.lineTo(812, gy - 8); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(622, gy - 30); ctx.lineTo(687, gy - 30); ctx.moveTo(747, gy - 30); ctx.lineTo(812, gy - 30); ctx.stroke();
  // gate pillars
  [683, 751].forEach((px) => {
    ctx.fillStyle = '#2b2418';
    ctx.fillRect(px - 6, gy - 52, 12, 54);
    ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 2;
    ctx.strokeRect(px - 6, gy - 52, 12, 54);
    ctx.fillStyle = '#FFD700';
    ctx.beginPath(); ctx.arc(px, gy - 56, 4.5, 0, Math.PI * 2); ctx.fill();
  });
  // sliding gate halves
  const slide = gateOpen * 30;
  const half = (cx, dir) => {
    const ox = cx + dir * slide;
    ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 2.5;
    for (let i = 0; i < 3; i++) {
      ctx.beginPath(); ctx.moveTo(ox + dir * i * 9, gy - 2); ctx.lineTo(ox + dir * i * 9, gy - 40); ctx.stroke();
    }
    ctx.lineWidth = 3.5;
    ctx.beginPath(); ctx.moveTo(ox, gy - 6); ctx.lineTo(ox + dir * 24, gy - 6); ctx.moveTo(ox, gy - 36); ctx.lineTo(ox + dir * 24, gy - 36); ctx.stroke();
  };
  half(690, -1);
  half(744, 1);
  // R monogram (fades as the gate opens)
  if (gateOpen < 0.6) {
    ctx.font = 'bold 18px serif'; ctx.textAlign = 'center';
    ctx.fillStyle = `rgba(255,215,0,${(1 - gateOpen / 0.6) * (0.7 + Math.abs(Math.sin(t * 0.06)) * 0.3)})`;
    ctx.shadowColor = '#FFD700'; ctx.shadowBlur = 8;
    ctx.fillText('R', 717, gy - 14);
    ctx.shadowBlur = 0;
  }
  // opening glow
  if (gateOpen > 0.05 && gateOpen < 0.98) {
    ctx.fillStyle = `rgba(253,224,71,${0.18 * Math.sin(gateOpen * Math.PI)})`;
    ctx.fillRect(687, gy - 44, 60, 46);
  }
  // plaque
  ctx.fillStyle = 'rgba(0,0,0,0.7)';
  ctx.fillRect(560, gy + 6, 116, 14);
  ctx.font = 'bold 8px monospace'; ctx.textAlign = 'center';
  ctx.fillStyle = '#FFD700';
  ctx.fillText("RANDALL'S PLOT · PRIVATE", 618, gy + 16);
}

export function drawGodsRoom(ctx, sub, t) {
  ctx.save();
  ctx.textAlign = 'center';
  if (sub === 'g_basement') {
    ctx.fillStyle = '#3f3f46';
    ctx.beginPath(); ctx.arc(640, 210, 52, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = '#a1a1aa'; ctx.lineWidth = 5;
    ctx.beginPath(); ctx.arc(640, 210, 52, 0, Math.PI * 2); ctx.stroke();
    ctx.beginPath(); ctx.arc(640, 210, 20, 0, Math.PI * 2); ctx.stroke();
    [[130, 250], [210, 250], [170, 226]].forEach(([gx, gy]) => {
      for (let g = 0; g < 3; g++) {
        ctx.fillStyle = '#fbbf24';
        ctx.fillRect(gx + g * 24, gy, 20, 10);
        ctx.strokeStyle = '#92400e'; ctx.lineWidth = 1;
        ctx.strokeRect(gx + g * 24, gy, 20, 10);
      }
    });
    for (let i = 0; i < 3; i++) {
      ctx.fillStyle = '#4a2c14';
      ctx.fillRect(360 + i * 60, 210, 40, 56);
      ctx.strokeStyle = '#2b1a0c'; ctx.lineWidth = 2;
      ctx.strokeRect(360 + i * 60, 210, 40, 56);
    }
    const fl = 0.5 + Math.abs(Math.sin(t * 0.2)) * 0.5;
    ctx.fillStyle = `rgba(253,224,71,${fl * 0.5})`;
    ctx.beginPath(); ctx.arc(400, 96, 26 * fl + 8, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#fde047';
    ctx.beginPath(); ctx.arc(400, 96, 6, 0, Math.PI * 2); ctx.fill();
    ctx.font = 'bold 10px monospace'; ctx.fillStyle = 'rgba(255,255,255,0.5)';
    ctx.fillText('THE VAULT', 640, 290);
  } else if (sub === 'g_lobby') {
    [140, 660].forEach((cx2) => {
      ctx.fillStyle = '#d4af37';
      ctx.fillRect(cx2 - 12, 90, 24, 210);
      ctx.fillRect(cx2 - 22, 82, 44, 12);
      ctx.fillRect(cx2 - 22, 296, 44, 12);
      ctx.fillStyle = 'rgba(255,255,255,0.25)';
      ctx.fillRect(cx2 - 4, 90, 5, 210);
    });
    ctx.fillStyle = '#7f1d1d';
    ctx.fillRect(330, 300, 140, 200);
    ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 2;
    ctx.strokeRect(330, 300, 140, 200);
    const g2 = 0.6 + Math.abs(Math.sin(t * 0.06)) * 0.4;
    ctx.font = 'bold 34px serif';
    ctx.fillStyle = `rgba(255,215,0,${g2})`;
    ctx.shadowColor = '#FFD700'; ctx.shadowBlur = 16 * g2;
    ctx.fillText('THEGODS', 400, 150);
    ctx.shadowBlur = 0;
    ctx.font = '13px serif'; ctx.fillStyle = 'rgba(255,255,255,0.6)';
    ctx.fillText('~ house of Randall ~', 400, 172);
    for (let i = 0; i < 8; i++) {
      const a = (i / 8) * Math.PI * 2 + t * 0.02;
      ctx.fillStyle = '#fde68a';
      ctx.beginPath(); ctx.arc(400 + Math.cos(a) * 34, 218 + Math.sin(a) * 10, 3.4, 0, Math.PI * 2); ctx.fill();
    }
  } else if (sub === 'g_bath') {
    ctx.fillStyle = '#e2e8f0';
    ctx.beginPath();
    if (ctx.roundRect) ctx.roundRect(120, 210, 240, 90, 26); else ctx.rect(120, 210, 240, 90);
    ctx.fill();
    ctx.fillStyle = '#7dd3fc';
    ctx.beginPath();
    if (ctx.roundRect) ctx.roundRect(134, 222, 212, 56, 18); else ctx.rect(134, 222, 212, 56);
    ctx.fill();
    for (let i = 0; i < 5; i++) {
      const cyc = (t * 0.5 + i * 17) % 60;
      ctx.fillStyle = `rgba(255,255,255,${Math.max(0, 0.5 - cyc / 130)})`;
      ctx.beginPath(); ctx.arc(160 + i * 44, 214 - cyc * 0.5, 7 + cyc * 0.1, 0, Math.PI * 2); ctx.fill();
    }
    ctx.fillStyle = '#FFD700';
    ctx.fillRect(236, 190, 8, 24);
    ctx.beginPath(); ctx.arc(240, 214, 6, 0, Math.PI); ctx.fill();
    ctx.fillStyle = '#cbd5e1';
    ctx.fillRect(480, 120, 130, 160);
    ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 4;
    ctx.strokeRect(480, 120, 130, 160);
    ctx.fillStyle = 'rgba(255,255,255,0.35)';
    ctx.beginPath(); ctx.moveTo(495, 265); ctx.lineTo(555, 130); ctx.lineTo(585, 130); ctx.lineTo(520, 265); ctx.closePath(); ctx.fill();
    ctx.fillStyle = '#f8fafc';
    ctx.beginPath(); ctx.ellipse(680, 280, 40, 18, 0, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#e2e8f0';
    ctx.fillRect(664, 296, 32, 40);
    ctx.font = 'bold 10px monospace'; ctx.fillStyle = 'rgba(255,255,255,0.5)';
    ctx.fillText('MARBLE BATH', 240, 330);
  } else if (sub === 'g_lounge') {
    [[150, 280], [520, 280]].forEach(([sx2, sy2]) => {
      ctx.fillStyle = '#b45309';
      ctx.fillRect(sx2, sy2, 150, 44);
      ctx.fillStyle = '#FFD700';
      ctx.fillRect(sx2, sy2 - 22, 150, 26);
      ctx.fillRect(sx2 - 12, sy2 - 22, 14, 66);
      ctx.fillRect(sx2 + 148, sy2 - 22, 14, 66);
    });
    ctx.fillStyle = '#1c1917';
    ctx.fillRect(340, 140, 130, 120);
    const ff = 12 + Math.abs(Math.sin(t * 0.12)) * 14;
    ctx.fillStyle = '#f97316';
    ctx.beginPath(); ctx.ellipse(405, 248, 34, ff, 0, Math.PI, 0); ctx.fill();
    ctx.fillStyle = '#fde047';
    ctx.beginPath(); ctx.ellipse(405, 248, 18, ff * 0.55, 0, Math.PI, 0); ctx.fill();
    ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 3;
    ctx.strokeRect(340, 140, 130, 120);
    ctx.fillStyle = '#3a2a12'; ctx.fillRect(580, 130, 170, 8);
    ['#7c2d12', '#134e4a', '#701a75', '#FFD700'].forEach((c, i) => {
      ctx.fillStyle = c;
      ctx.fillRect(596 + i * 38, 96, 14, 34);
    });
    ctx.font = 'bold 10px monospace'; ctx.fillStyle = 'rgba(255,215,0,0.6)';
    ctx.fillText('GOLD LOUNGE', 400, 120);
  } else if (sub === 'g_observatory') {
    for (let i = 0; i < 60; i++) {
      const sx2 = (i * 131) % 790; const sy2 = 60 + ((i * 197) % 220);
      const tw = 0.3 + Math.abs(Math.sin(t * 0.06 + i)) * 0.7;
      ctx.fillStyle = `rgba(255,255,255,${tw})`;
      ctx.fillRect(sx2, sy2, i % 7 === 0 ? 2.5 : 1.5, i % 7 === 0 ? 2.5 : 1.5);
    }
    const sh = (t * 1.4) % 900;
    if (sh < 240) {
      ctx.strokeStyle = `rgba(255,255,255,${0.8 - sh / 300})`;
      ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(120 + sh * 2.4, 70 + sh * 0.55); ctx.lineTo(150 + sh * 2.4, 82 + sh * 0.55); ctx.stroke();
    }
    ctx.strokeStyle = 'rgba(125,211,252,0.5)'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(110, 100); ctx.lineTo(170, 140); ctx.lineTo(240, 110); ctx.lineTo(300, 160); ctx.stroke();
    ctx.fillStyle = '#334155';
    ctx.fillRect(360, 250, 90, 60);
    ctx.strokeStyle = '#94a3b8'; ctx.lineWidth = 12;
    ctx.beginPath(); ctx.moveTo(405, 260); ctx.lineTo(480, 150); ctx.stroke();
    ctx.strokeStyle = '#e2e8f0'; ctx.lineWidth = 5;
    ctx.beginPath(); ctx.moveTo(470, 164); ctx.lineTo(495, 128); ctx.stroke();
    ctx.fillStyle = '#fbbf24';
    ctx.beginPath(); ctx.arc(640, 110, 22, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = 'rgba(251,191,36,0.25)';
    ctx.beginPath(); ctx.ellipse(640, 110, 38, 9, -0.4, 0, Math.PI * 2); ctx.fill();
    ctx.font = 'bold 11px monospace'; ctx.fillStyle = 'rgba(125,211,252,0.75)';
    ctx.fillText('✦ STAR OBSERVATORY ✦', 400, 330);
  } else if (sub === 'g_security') {
    // wall of surveillance monitors
    for (let r = 0; r < 2; r++) for (let c = 0; c < 3; c++) {
      const mx = 150 + c * 120, my = 90 + r * 84;
      ctx.fillStyle = '#0a0f14';
      ctx.fillRect(mx, my, 104, 68);
      ctx.strokeStyle = '#334155'; ctx.lineWidth = 3;
      ctx.strokeRect(mx, my, 104, 68);
      // feed content — sweeping scan line + noise
      ctx.fillStyle = ['rgba(34,197,94,0.12)', 'rgba(56,189,248,0.12)', 'rgba(251,191,36,0.1)'][c];
      ctx.fillRect(mx + 4, my + 4, 96, 60);
      const scan = my + 4 + ((t * 1.4 + r * 30 + c * 20) % 60);
      ctx.fillStyle = 'rgba(74,222,128,0.5)';
      ctx.fillRect(mx + 4, scan, 96, 2);
      ctx.font = 'bold 7px monospace'; ctx.textAlign = 'left';
      ctx.fillStyle = 'rgba(74,222,128,0.8)';
      ctx.fillText(['GATE CAM', 'LOBBY', 'SKY CLUB', 'VAULT', 'DRIVEWAY', 'ROOF'][r * 3 + c], mx + 8, my + 14);
      const rec = Math.floor(t / 24) % 2 === 0;
      if (rec) { ctx.fillStyle = '#ef4444'; ctx.beginPath(); ctx.arc(mx + 94, my + 10, 3, 0, Math.PI * 2); ctx.fill(); }
    }
    // server rack
    ctx.fillStyle = '#111827';
    ctx.fillRect(560, 100, 90, 200);
    ctx.strokeStyle = '#334155'; ctx.lineWidth = 2;
    ctx.strokeRect(560, 100, 90, 200);
    for (let i = 0; i < 8; i++) {
      ctx.strokeRect(566, 108 + i * 23, 78, 18);
      const on = (Math.floor(t / 8) + i) % 4 !== 0;
      ctx.fillStyle = on ? '#22c55e' : '#14532d';
      ctx.beginPath(); ctx.arc(636, 117 + i * 23, 2.6, 0, Math.PI * 2); ctx.fill();
    }
    // control desk
    ctx.fillStyle = '#1f2937';
    ctx.fillRect(180, 280, 300, 34);
    ctx.fillStyle = '#0ea5e9';
    for (let i = 0; i < 9; i++) ctx.fillRect(196 + i * 30, 290, 16, 6);
    // rotating red alarm beacon
    const aa = t * 0.08;
    ctx.fillStyle = 'rgba(239,68,68,0.16)';
    ctx.beginPath(); ctx.moveTo(400, 52);
    ctx.lineTo(400 + Math.cos(aa) * 300, 52 + Math.abs(Math.sin(aa)) * 240);
    ctx.lineTo(400 + Math.cos(aa + 0.5) * 300, 52 + Math.abs(Math.sin(aa + 0.5)) * 240);
    ctx.closePath(); ctx.fill();
    ctx.fillStyle = '#ef4444';
    ctx.beginPath(); ctx.arc(400, 52, 8, 0, Math.PI * 2); ctx.fill();
    ctx.textAlign = 'center';
    ctx.font = 'bold 11px monospace';
    ctx.fillStyle = `rgba(239,68,68,${0.6 + Math.abs(Math.sin(t * 0.1)) * 0.4})`;
    ctx.fillText('🔒 SECURITY — RANDALL ONLY 🔒', 400, 340);
  } else if (sub === 'g_club') {
    for (let r = 0; r < 4; r++) for (let c = 0; c < 8; c++) {
      const on = (r + c + Math.floor(t / 14)) % 3;
      ctx.fillStyle = ['#7c3aed', '#db2777', '#0ea5e9'][on] + '55';
      ctx.fillRect(180 + c * 55, 250 + r * 44, 51, 40);
    }
    ctx.fillStyle = '#111';
    ctx.fillRect(300, 130, 200, 70);
    ctx.strokeStyle = '#c084fc'; ctx.lineWidth = 2;
    ctx.strokeRect(300, 130, 200, 70);
    for (let b = 0; b < 10; b++) {
      const bh = 6 + Math.abs(Math.sin(t * 0.14 + b)) * 26;
      ctx.fillStyle = `hsl(${(b * 36 + t * 4) % 360}, 90%, 60%)`;
      ctx.fillRect(312 + b * 18, 194 - bh, 10, bh);
    }
    ctx.font = 'bold 12px monospace'; ctx.fillStyle = '#c084fc';
    ctx.fillText('DJ THEGODS', 400, 156);
    const da = t * 0.04;
    ctx.fillStyle = '#e5e7eb';
    ctx.beginPath(); ctx.arc(400, 84, 20, 0, Math.PI * 2); ctx.fill();
    for (let i = 0; i < 7; i++) {
      const a = da + (i / 7) * Math.PI * 2;
      ctx.strokeStyle = `hsla(${(i * 51 + t * 5) % 360}, 90%, 65%, 0.55)`;
      ctx.lineWidth = 2.5;
      ctx.beginPath(); ctx.moveTo(400, 84);
      ctx.lineTo(400 + Math.cos(a) * 330, 84 + Math.sin(a) * 250); ctx.stroke();
    }
    [140, 660].forEach((sx2) => {
      ctx.fillStyle = '#18181b';
      ctx.fillRect(sx2 - 26, 170, 52, 84);
      const pump = 1 + Math.abs(Math.sin(t * 0.16)) * 0.25;
      ctx.strokeStyle = '#a78bfa'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.arc(sx2, 200, 12 * pump, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.arc(sx2, 232, 8 * pump, 0, Math.PI * 2); ctx.stroke();
    });
    ctx.font = 'bold 11px monospace';
    ctx.fillStyle = `rgba(192,132,252,${0.55 + Math.abs(Math.sin(t * 0.08)) * 0.45})`;
    ctx.fillText('☁ SKY CLUB — TOP OF THEGODS ☁', 400, 236);
  }
  ctx.restore();
}
